var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"tw:block tw:text-sm tw:font-bold tw:text-slate-700 tw:mb-1.5"},[_vm._v(" "+_vm._s(_vm.title)+" "),(_vm.required)?_c('span',{staticClass:"tw:text-red-500 tw:ml-0.5"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }